import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import PublishIcon from '@mui/icons-material/Publish';
import RepeatIcon from '@mui/icons-material/Repeat';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Button, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import axios from 'axios';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { googleCSVImport, isUniqueFileImport } from '../../../asyncHelpers/importCsvService';
import { RequestStatus } from '../../../sic-lib/enums/RequestStatus';
import {
    ImportGoogleCSVRequest,
    IsUniqueFileImportRequest,
} from '../../../sic-lib/types/GoogleImportCSV';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { mapCsvToJson } from '../../../utils/csv2json';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        '& > div': {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    },
    button: {
        margin: theme.spacing(1),
    },
    paper: {
        padding: '6px 16px',
    },
}));

function CSVImport<React, FC>() {
    const dispatch = useAppDispatch();
    const { classes } = useStyles();
    const request_token = axios.CancelToken.source();
    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);
    const [importErrors, setImportErrors] = React.useState<string | null>(null);
    var [csvData, setCSVData] = React.useState<string>('');
    var [csvName, setCSVName] = React.useState<string>('');
    var [shoudOverride, setShoudOverride] = React.useState<boolean>(false);
    var [isDone, setIsDone] = React.useState<boolean>(false);
    var [totalImports, setTotalImports] = React.useState<number>(0);
    var [overrideState, setOverrideState] = React.useState<boolean>(false);

    var [sucessfulImports, setSucessfulImports] = React.useState<number>(0);
    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const clientId = useAppSelector(state => state.user?.clientId || -1);
    var testCSVSTRING: string = '';
    // const [formData, setFormData] = React.useState<JSON>();

    const handleFileSelect = (selectorFiles: FileList | null) => {
        if (selectorFiles && selectorFiles.length > 0) {
            let file: File | null = selectorFiles.item(0);
            if (file) {
                let reader: FileReader = new FileReader();
                reader.readAsText(file);
                reader.onload = async e => {
                    //setCSVData(reader.result as string);
                    //setCSVData(mapCsvToJson(reader.result))
                    csvData = mapCsvToJson(reader.result);
                    setCSVName(file?.name ? file?.name : 'noName');
                    setCSVData(mapCsvToJson(reader.result));

                    console.log('csvData.length', csvData.length);
                    console.log('CSVData', csvData);
                    console.log('file size:, ', file?.size);

                    let requestDataIsUnique: IsUniqueFileImportRequest = {
                        clientId: clientId,
                        fileName: file?.name ? file?.name : 'noName',
                        fileSize: file?.size ? file?.size : 1,
                    };
                    //const response = await isUniqueFileImport(clientId, file?.size ? file?.size : 1, request_token.token, file?.name ? file?.name : "");
                    const response = await isUniqueFileImport(requestDataIsUnique);
                    //here json

                    //setFormData(mapCsvToJson(csv));
                    //importContactsData(mapCsvToJson(csvData));
                };
            }
        }
    };
    const handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOverrideState(event.target.checked);
    };
    const handleCloseImport = () => {
        //~ reset fields to default
        setImportErrors(null);
    };
    const renderImButton = () => {
        if (csvData.length > 1) {
            return (
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineDot color="primary" variant="outlined">
                            <LaptopMacIcon />
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                        <Paper elevation={3} className={classes.paper}>
                            <Typography variant="h6" component="h1">
                                Almost there!
                            </Typography>
                            <Typography>One click away </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                startIcon={<ImportContactsIcon />}
                                onClick={() => importContactsData(csvData, csvName)}
                            >
                                Import
                            </Button>
                        </Paper>
                    </TimelineContent>
                </TimelineItem>
            );
        }
    };
    const renderOverrideState = () => {
        //dont render override options for now
        //if (false) {
        //    return <TimelineItem>
        //        <TimelineOppositeContent>
        //            <Typography variant="body2" color="textSecondary">
        //                Step 2
        //  </Typography>
        //        </TimelineOppositeContent>
        //        <TimelineSeparator>
        //            <TimelineDot color="primary">
        //                <GavelIcon />
        //            </TimelineDot>
        //            <TimelineConnector />
        //        </TimelineSeparator>
        //        <TimelineContent>
        //            <Paper elevation={3} className={classes.paper}>
        //                <FormControlLabel
        //                    control={
        //                        <Switch
        //                            checked={overrideState}
        //                            onChange={handleStateChange}
        //                            name="Override"
        //                            color="primary"
        //                        />
        //                    }
        //                    label="Override"
        //                />
        //                <Typography variant="h6" component="h1">
        //                    Override or skip if field has data in it.
        //    </Typography>
        //                <Typography>The same file name, exists in our record! Do you want to proceed?</Typography>
        //            </Paper>
        //        </TimelineContent>
        //    </TimelineItem>
        //}
    };
    const renderResults = () => {
        if (isDone) {
            return (
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineDot color="secondary">
                            <RepeatIcon />
                        </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                        <Paper elevation={3} className={classes.paper}>
                            <Typography variant="h6" component="h1">
                                All Done!
                            </Typography>
                            <Typography>
                                {' '}
                                {sucessfulImports} out of {totalImports} contacts were succesfully
                                imported.{' '}
                            </Typography>
                        </Paper>
                    </TimelineContent>
                </TimelineItem>
            );
        }
    };

    const importContactsData = async (importData: string, fileName: string) => {
        try {
            setRequestStatus(RequestStatus.active);
            let requestData: ImportGoogleCSVRequest = {
                clientId: clientId,
                json: importData,
                fileName: fileName,
            };
            //const response = await googleCSVImport(clientId, importData, request_token.token);
            const response = await googleCSVImport(requestData);

            //dispatch(contactActions.importContacts(response.data));
            setIsDone(true);
            isDone = true;
            setTotalImports(response.data.totalRows);
            setSucessfulImports(response.data.succesfullyImportedRows);
            setRequestStatus(RequestStatus.none);
            setImportErrors(null);
            handleCloseImport();
        } catch (e: any) {
            if (!axios.isCancel) {
                console.log('Error - importContactsData', e.response.data);

                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return (
        <div className={classes.root}>
            <div>
                <Timeline position="left">
                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography variant="body2" color="textSecondary">
                                Step 1
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot>
                                <PublishIcon />
                            </TimelineDot>
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper}>
                                <Typography variant="h6" component="h1">
                                    Upload file
                                </Typography>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={e => handleFileSelect(e.target.files)}
                                />
                            </Paper>
                        </TimelineContent>
                    </TimelineItem>
                    {renderOverrideState()}
                    {renderImButton()}

                    {renderResults()}
                </Timeline>
            </div>
        </div>
    );
    {
        //}
        //else {
        //    return (
        //        <div className={classes.root}>
        //            <div>
        //                Successfully imported {sucessfulImports} out of {totalImports}
        //            </div>
        //        </div>
        //    );
        //}
    }
}

export default CSVImport;
